import React from "react";

import { UnauthorizedSellersList } from "../../../components/GdkMiddlewareRequest";
import {
  gdkRequestUnauthorizedMessage,
  gdkRequestUnauthorizedTitle,
} from "../gdkMiddlewarePageContent";
import * as styles from "../GdkMiddlewareRequestPage.module.css";

export const UnauthorizedStep = () => (
  <>
    <h1 className={styles.title2}>{gdkRequestUnauthorizedTitle}</h1>
    <p>{gdkRequestUnauthorizedMessage}</p>
    <UnauthorizedSellersList />
  </>
);
